import axios from 'axios';

function interceptor(uuid, prequalSource, path, countryCode, languageCode) {
  axios.interceptors.request.use(
    (config) => {
      config.headers.UUID = uuid;
      config.headers.Source = prequalSource || 'web';
      config.headers.Path = path;
      config.headers.CountryCode = countryCode;
      config.headers.LanguageCode = languageCode;
      return config;
    },
    (error) => Promise.reject(error)
  );
}

export default interceptor;
